'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _WindIndicator = require('./WindIndicator');

var _WindIndicator2 = _interopRequireDefault(_WindIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _WindIndicator2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/WindIndicator/index.js
// module id = 699
// module chunks = 11